import {
  AAF_FLOW_CALL_CENTER,
  AAF_FLOW_ADDON,
  AAF_FLOW_PACKAGE
} from 'src/AAFPlayer/constants.js';

type FlowType = typeof AAF_FLOW_ADDON | typeof AAF_FLOW_PACKAGE | typeof AAF_FLOW_CALL_CENTER;

const FLOWS: FlowType[] = [AAF_FLOW_ADDON, AAF_FLOW_PACKAGE, AAF_FLOW_CALL_CENTER];

const PRIMARY_COLOR_KEY = "Color_ColorPrimario";
const SECONDARY_COLOR_KEY = "Color_ColorSecundario";
const SHORCUT_COLOR_BACK_KEY = "Color_ShortcutAmarillo";
const PROMOTION_COLOR_KEY = "Color_ColorTextoPromocion";
const WHATINCLUDES_COLOR_KEY = "Color_ColorQueIncluye";
const SHORCUT_COLOR_BLUE_KEY = "Color_ShortcutAzul";
const SHORCUT_TITLE_BACK_KEY = "BotonShortcut_TextoTitulo_Regresar";
const SHORCUT_TITLE_INCLUDES_KEY = "BotonShortcut_TextoTitulo";

interface IContentKeys {
  primaryColor: Record<FlowType, string>;
  secondaryColor: Record<FlowType, string>;
  shorcutBackColor: Record<FlowType, string>;
  promotionColor: Record<FlowType, string>;
  whatIncludesColor: Record<FlowType, string>;
  shorcutBlueColor: Record<FlowType, string>;
  shorcutBackTitle: Record<FlowType, string>;
  shorcutBlueTitle: Record<FlowType, string>;
  title: Record<FlowType, string>;
  textTemporability: Record<FlowType, string>;
  textTaxes: Record<FlowType, string>;
  textOffer: Record<FlowType, string>;
  textPromotion: Record<FlowType, string>;
  textPromotion2: Record<FlowType, string>;
  textPromotion3: Record<FlowType, string>;
  textWhatIncludes: Record<FlowType, string>;
  textPrimaryButton: Record<FlowType, string>;
  textSecondaryButton: Record<FlowType, string>;
  textButton1: Record<FlowType, string>;
  textButton2: Record<FlowType, string>;
  colorButtonPromotion: Record<FlowType, string>;
  buttonSubscriptionColor: Record<FlowType, string>;
  callCenterPhone: Record<FlowType, string>;
  callCenterText1: Record<FlowType, string>;
  callCenterText2: Record<FlowType, string>;
  callCenterText3: Record<FlowType, string>;
  callCenterText4: Record<FlowType, string>;
  callCenterText5: Record<FlowType, string>;
  imageLogoImage: Record<FlowType, string>;
  backgroundImage: Record<FlowType, string>;
}

const buildMap = (value: string): Record<FlowType, string> =>
  FLOWS.reduce((acc, flow) => ({ ...acc, [flow]: value }), {} as Record<FlowType, string>);

const CONTENT_KEYS: IContentKeys = {
  primaryColor: buildMap(PRIMARY_COLOR_KEY),
  secondaryColor: buildMap(SECONDARY_COLOR_KEY),
  shorcutBackColor: buildMap(SHORCUT_COLOR_BACK_KEY),
  promotionColor: buildMap(PROMOTION_COLOR_KEY),
  whatIncludesColor: buildMap(WHATINCLUDES_COLOR_KEY),
  shorcutBlueColor: buildMap(SHORCUT_COLOR_BLUE_KEY),
  shorcutBackTitle: buildMap(SHORCUT_TITLE_BACK_KEY),
  shorcutBlueTitle: buildMap(SHORCUT_TITLE_INCLUDES_KEY),
  title: {
    [AAF_FLOW_ADDON]: "Transaccionales_ContratacionCanalesUnica_TextoTitulo",
    [AAF_FLOW_PACKAGE]: "Transaccionales_ContratacionCanalesMultiple_TextoTitulo",
    [AAF_FLOW_CALL_CENTER]: "Transaccionales_CallCenter_TextoTitulo_",
  },
  textTemporability: {
    [AAF_FLOW_ADDON]: "Transaccionales_ContratacionCanalesUnica_TextoTemporalidad_",
    [AAF_FLOW_PACKAGE]: "Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoTemporalidad_",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  textTaxes: {
    [AAF_FLOW_ADDON]: "Transaccionales_TextoImpuestos_",
    [AAF_FLOW_PACKAGE]: "Transaccionales_TextoImpuestos_",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  textOffer: {
    [AAF_FLOW_ADDON]: "Transaccionales_ContratacionCanalesUnica_TextoOferta_",
    [AAF_FLOW_PACKAGE]: "",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  textPromotion: {
    [AAF_FLOW_ADDON]: "Transaccionales_ContratacionCanalesUnica_TextoPromocion_",
    [AAF_FLOW_PACKAGE]: "Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoPromocion1_",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  textPromotion2: {
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoPromocion2_",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  textPromotion3: {
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoPromocion3_",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  textWhatIncludes: {
    [AAF_FLOW_ADDON]: "Transaccionales_ContratacionCanalesUnica_TextoBotonIncluye_",
    [AAF_FLOW_PACKAGE]: "",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  textPrimaryButton:{
    [AAF_FLOW_ADDON]: "Transaccionales_ContratacionCanalesUnica_TextoBotonPrimarioContratar",
    [AAF_FLOW_PACKAGE]: "",
    [AAF_FLOW_CALL_CENTER]: "Transaccionales_CallCenter_TextoBotonPrimarioAceptar_",
  },
  textSecondaryButton:{
    [AAF_FLOW_ADDON]: "Transaccionales_ContratacionCanalesUnica_TextoBotonSecundarioCancelar",
    [AAF_FLOW_PACKAGE]: "",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  textButton1:{
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoBoton1_",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  textButton2:{
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "Transaccionales_ContratacionCanalesMultiple_Tarjeta_TextoBoton2_",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  colorButtonPromotion:{
    [AAF_FLOW_ADDON]: "Color_ColorTextoPromocion",
    [AAF_FLOW_PACKAGE]: "",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  buttonSubscriptionColor: {
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "Transaccionales_ContratacionCanalesMultiple_Tarjeta_ColorBotonSubscripcion_",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  callCenterPhone:{
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "",
    [AAF_FLOW_CALL_CENTER]: "Transaccionales_CallCenter_TextoTelefono_",
  },
  callCenterText1:{
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "",
    [AAF_FLOW_CALL_CENTER]: "Transaccionales_CallCenter_TextoParrafo1_",
  },
  callCenterText2:{
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "",
    [AAF_FLOW_CALL_CENTER]: "Transaccionales_CallCenter_TextoParrafo2_",
  },
  callCenterText3:{
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "",
    [AAF_FLOW_CALL_CENTER]: "Transaccionales_CallCenter_TextoParrafo3_",
  },
  callCenterText4:{
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "",
    [AAF_FLOW_CALL_CENTER]: "Transaccionales_CallCenter_TextoParrafo4_",
  },
  callCenterText5:{
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "",
    [AAF_FLOW_CALL_CENTER]: "Transaccionales_CallCenter_TextoParrafo5_",
  },
  imageLogoImage: {
    [AAF_FLOW_ADDON]: "Transaccionales_ContratacionCanalesUnica_LogoAddon_",
    [AAF_FLOW_PACKAGE]: "Transaccionales_ContratacionCanalesMultiple_Tarjeta_ImagenLogo_",
    [AAF_FLOW_CALL_CENTER]: "",
  },
  backgroundImage: {
    [AAF_FLOW_ADDON]: "",
    [AAF_FLOW_PACKAGE]: "Transaccionales_ContratacionCanalesMultiple_Tarjeta_ImagenFondo_",
    [AAF_FLOW_CALL_CENTER]: "",
  }
};

export { CONTENT_KEYS };



// WEBPACK FOOTER //
// ./src/components/Modal/constants/ModalAddon/constants.ts